import axios from 'axios';
import axiosInstance from './AxiosService';

const appPasswordService = {
  fetchAppPassword: async () => {
    try {
      const response = await axiosInstance.get('applications/password/');
      return response.data;
    } catch (error) {
      console.error(`Error fetching all password data: ${error.message}`);
      return null;
    }
  },

  fetchAppPasswordbyID: async (APP_NAME) => {
    try {
      // Try the primary endpoint first
      const response = await axiosInstance.get(`fetch-app-password/${APP_NAME}/`);
      // Check if the response contains an error detail
      if (response.data && response.data.detail) {
        throw new Error(response.data.detail);
      }
      return response.data;
    } catch (primaryError) {
      console.error(`Error fetching password data from primary endpoint: ${primaryError.message}`);
      
      try {
        // If primary endpoint fails, try alternative endpoint
        const alternativeResponse = await axiosInstance.get(`app-password/appid/${APP_NAME}/`);
        // Check if the response contains an error detail
        if (alternativeResponse.data && alternativeResponse.data.detail) {
          throw new Error(alternativeResponse.data.detail);
        }
        return alternativeResponse.data;
      } catch (alternativeError) {
        console.error(`Error fetching password data from alternative endpoint: ${alternativeError.message}`);
        // Return null to indicate no record was found
        return null;
      }
    }
  },

  fetchAppPasswordByApp: async (APP_NAME) => {
    try {
      const response = await axiosInstance.get(`app-password/appid/${APP_NAME}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching password data by app ID: ${error.message}`);
      return null;
    }
  },

  createAppPassword: async (passwordData) => {
    try {
      // Log the data being sent for debugging
      console.log('Creating password with data:', passwordData);
      
      // Ensure APP_NAME exists in the data
      if (!passwordData.APP_NAME) {
        throw new Error('APP_NAME is required when creating a password record');
      }
      
      const response = await axiosInstance.post('app-password/', passwordData);
      console.log('Password creation response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error creating password data: ${error.message}`);
      if (error.response) {
        console.error('Response error data:', error.response.data);
        console.error('Response status:', error.response.status);
        
        // If the error is that the record already exists, try updating instead
        if (error.response.status === 400 && 
            error.response.data && 
            (error.response.data.detail === 'Record already exists' || 
             error.response.data.APP_NAME)) {
          console.log('Record exists, trying to update instead');
          try {
            // Try to update the existing record
            const updateResponse = await axiosInstance.put(`app-password/appid/${passwordData.APP_NAME}/`, passwordData);
            console.log('Password update (after failed create) response:', updateResponse.data);
            return updateResponse.data;
          } catch (updateError) {
            console.error('Failed to update after create attempt:', updateError);
            throw updateError;
          }
        }
      }
      throw error;
    }
  },

  updateAppPassword: async (appId, passwordData) => {
    try {
      // Log the data being sent for debugging
      console.log('Updating password with data:', passwordData);
      console.log('For app ID:', appId);
      
      const response = await axiosInstance.put(`app-password/appid/${appId}/`, passwordData);
      console.log('Password update response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error updating password data: ${error.message}`);
      if (error.response) {
        console.error('Response error data:', error.response.data);
        console.error('Response status:', error.response.status);
      }
      throw error;
    }
  },

  deleteAppPassword: async (appId) => {
    try {
      const response = await axiosInstance.delete(`applications/password/${appId}/`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting password data: ${error.message}`);
      throw error;
    }
  }
};

export default appPasswordService;
